import React from "react";
import { Button } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

const OvertimeBtn = () => {
  return (
    <>
      <Link to="/overtime">
        <Button
          style={{
            background: "#FF7201",
            color: "#FFFFFF",
            borderRadius: "50px",
          }}
        >
          <ClockCircleOutlined />
          OVERTIME
        </Button>
      </Link>
    </>
  );
};

export default OvertimeBtn;
